import type { ListSchema } from '~/client/src/shared/lists/core'
import Localization from '~/client/src/shared/localization/LocalizationManager'

export function withDefaultOptionLabels<T>(
  schema: ListSchema<T>,
): ListSchema<T> {
  return {
    ...schema,
    emptyOptionLabel:
      schema.emptyOptionLabel ?? Localization.translator.unassigned,
  }
}
